import { useQuery } from "hooks/useQuery";
import { getPortfolioTradingConnectionPositions } from "../service";

export const useStrategyPositions = (tradingConnectionId, search = "") => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: [
      "strategyPositions",
      tradingConnectionId,
      search ? search : null,
    ],
    queryFn: async () => {
      const params = search ? { search } : {};
      const response = await getPortfolioTradingConnectionPositions(
        tradingConnectionId,
        params
      );
      return response;
    },
    enabled: Boolean(tradingConnectionId),
  });

  return {
    isLoading,
    positionsData: data || [],
    refetch,
  };
};
